import React from 'react'
import ReactDOM from 'react-dom'

import classNames from 'classnames'

import { useEvolvedContext } from '../../context'
import style from './index.module.scss'

type DisplayMode = 'embedded' | 'visibleModal' | 'hiddenModal'

interface SearchContainerProps {
  children: React.ReactNode
  displayMode: DisplayMode
}

function getModal(): HTMLElement {
  const existing = document.getElementById('search-modal')
  if (existing !== null) {
    return existing
  }
  const modal = document.createElement('div')
  modal.id = 'search-modal'
  document.body.appendChild(modal)
  return modal
}

export const SearchContainer: React.FC<SearchContainerProps> = ({
  displayMode,
  children,
}) => {
  const isEvolved = useEvolvedContext()
  const styles = [style.Search]
  if (isEvolved) {
    styles.push(style.wevoTheme)
  }
  if (displayMode !== 'embedded') {
    styles.push(style.modal)
  }
  const searchClassName = classNames(...styles)

  if (typeof window !== 'undefined' && displayMode === 'visibleModal') {
    return ReactDOM.createPortal(
      <div className={searchClassName} id="universal-search-modal">
        {children}
      </div>,
      getModal()
    )
  } else if (displayMode === 'embedded') {
    return <div className={searchClassName}>{children}</div>
  } else {
    return null
  }
}

export default SearchContainer
